import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { RestService } from '../../rest.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    contact_form,
    current_page,
    contact_form_field,
    contactFormValidation,
    campaign,
    button_name,
    submite_button_color,
    send_id,
    country,
    list,
    user_id,
    utm_source,
    form_type,
    utm_medium,
    utm_term,
}

@Component({
    selector: 'app-contactformdialog',
    templateUrl: './contactformdialog.component.html',
    styleUrls: ['./contactformdialog.component.css']
})
export class ContactformdialogComponent implements OnInit {

    @ViewChild('fileInput') fileInput: ElementRef;
    fileAttr = 'Choose File';

    public user_id: any;
    public country: any;
    public list: any;
    public send_idd: any;
    public contact_form: any;
    public contact_form_field: any;
    public campaign: any;
    public current_page: any;
    public contactFormValidation: any;
    public button_name: any;
    public submite_button_color: any;
    public popupform_userdata: any;
    public empty: any = '';
    public utm_source: any;
    public isButtonLoading: boolean = false;
    public form_type: any;
    public preview_url: any = this.restApi.preview_url;
    public utm_medium:any;
    public utm_term:any;

    contactForm = new FormGroup({
        first_name: new FormControl(''),
        last_name: new FormControl(''),
        contact: new FormControl(''),
        gender: new FormControl(''),
        email: new FormControl(''),
        company: new FormControl(''),
        address: new FormControl(''),
        language: new FormControl(''),
        allow: new FormControl(''),
        description: new FormControl(''),
        date_of_birth: new FormControl(''),
        marital_status: new FormControl(''),
        education: new FormControl(''),
        aadhaar_card_no: new FormControl(''),
        salary: new FormControl(''),
        company_address: new FormControl(''),
        job_title: new FormControl(''),
        image: new FormControl(''),
    });

    constructor(
        public restApi: RestService,
        private _snackBar: MatSnackBar,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialogRef: MatDialogRef<ContactformdialogComponent>
    ) {
        this.campaign               = this.data.campaign;
        this.current_page           = this.data.current_page;
        this.contact_form           = this.data.contact_form;
        this.contact_form_field     = this.data.contact_form_field
        this.contactFormValidation  = this.data.contactFormValidation
        this.button_name            = this.data.button_name;
        this.submite_button_color   = this.data.submite_button_color;
        this.send_idd               = this.data.send_id;
        this.country                = this.data.country;
        this.list                   = this.data.list;
        this.user_id                = this.data.user_id;
        this.form_type              = this.data.form_type;
        this.utm_source             = this.data.utm_source;
        this.utm_medium             = this.data.utm_medium;
        this.utm_term               = this.data.utm_term;
       
    }

    ngOnInit(): void {
        this.get_form_autofill();
    }

    async get_form_autofill() {
        this.popupform_userdata = await JSON.parse(localStorage.getItem('popupform_userdata'));
    }

    uploadFileEvt(imgFile: any) {
        if (imgFile.target.files && imgFile.target.files[0]) {
            this.fileAttr = '';

            Array.from(imgFile.target.files).forEach((file: File) => {
                this.fileAttr += file.name + ' - ';
            });

            let reader = new FileReader();
            reader.onload = (e: any) => {
                let image = new Image();
                image.src = e.target.result;
                image.onload = rs => {
                    let imgBase64Path = e.target.result;
                    
                    this.contactForm.get("image").setValue(imgBase64Path, { emitEvent: false });
                };
            };
            reader.readAsDataURL(imgFile.target.files[0]);

            this.fileInput.nativeElement.value = "";
        } else {
            this.fileAttr = 'Choose File';
        }
    }

    submitForm() {

        var all_value = this.contactForm.value;
        var status = 0;

        if (this.contactFormValidation.first_name == true) {
            if (all_value.first_name == '') {
                this.contactFormValidation.first_name_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.first_name_error_msg = "";
            }
        }

        if (this.contactFormValidation.last_name == true) {
            if (all_value.last_name == '') {
                this.contactFormValidation.last_name_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.last_name_error_msg = "";
            }
        }

        if (this.contactFormValidation.contact == true) {
            if (all_value.contact == null || all_value.contact == '') {
                this.contactFormValidation.contact_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.contact_error_msg = "";
            }
        }

        if(all_value.contact != null || all_value.contact != ''){
            if(!this.CheckNumber(all_value.contact)){
                this.contactFormValidation.contact_error_msg = "Please enter your correct 10 digit number";
                status++;  
            }else{
                this.contactFormValidation.contact_error_msg = "";
            }
        }

        if (this.contactFormValidation.gender == true) {
            if (all_value.gender == '') {
                this.contactFormValidation.gender_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.gender_error_msg = "";
            }
        }

        if (this.contactFormValidation.email == true) {
            if (all_value.email == '') {
                this.contactFormValidation.email_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.email_error_msg = "";
            }
        }

        if(all_value.email != '') {
            if(!this.CheckEmail(all_value.email)) {
                this.contactFormValidation.email_error_msg = "Please enter right email address";
                status++;  
            }else{
                this.contactFormValidation.email_error_msg = "";
            }
        }

        if (this.contactFormValidation.company == true) {
            if (all_value.company == '') {
                this.contactFormValidation.company_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.company_error_msg = "";
            }
        }

        if (this.contactFormValidation.address == true) {
            if (all_value.address == '') {
                this.contactFormValidation.address_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.address_error_msg = "";
            }
        }

        if (this.contactFormValidation.language == true) {
            if (all_value.language == '') {
                this.contactFormValidation.language_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.language_error_msg = "";
            }
        }

        if (this.contactFormValidation.allow == true) {
            if (all_value.allow == '') {
                this.contactFormValidation.allow_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.allow_error_msg = "";
            }
        }

        if (this.contactFormValidation.description == true) {
            if (all_value.description == '') {
                this.contactFormValidation.description_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.description_error_msg = "";
            }
        }

        if (this.contactFormValidation.date_of_birth == true) {
            if (all_value.date_of_birth == '') {
                this.contactFormValidation.date_of_birth_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.date_of_birth_error_msg = "";
            }
        }

        if (this.contactFormValidation.marital_status == true) {
            if (all_value.marital_status == '') {
                this.contactFormValidation.marital_status_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.marital_status_error_msg = "";
            }
        }

        if (this.contactFormValidation.education == true) {
            if (all_value.education == '') {
                this.contactFormValidation.education_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.education_error_msg = "";
            }
        }

        if (this.contactFormValidation.aadhaar_card_no == true) {
            if (all_value.aadhaar_card_no == '') {
                this.contactFormValidation.aadhaar_card_no_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.aadhaar_card_no_error_msg = "";
            }
        }

        if (this.contactFormValidation.salary == true) {
            if (all_value.salary == '') {
                this.contactFormValidation.salary_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.salary_error_msg = "";
            }
        }

        if (this.contactFormValidation.company_address == true) {
            if (all_value.company_address == '') {
                this.contactFormValidation.company_address_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.company_address_error_msg = "";
            }
        }

        if (this.contactFormValidation.job_title == true) {
            if (all_value.job_title == '') {
                this.contactFormValidation.job_title_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.job_title_error_msg = "";
            }
        }

        if (this.contactFormValidation.image == true) {
            if (all_value.image == '') {
                this.contactFormValidation.image_error_msg = "Required field.";
                status++;
            }else {
                this.contactFormValidation.image_error_msg = "";
            }
        }

        if (status > 0) {
            return false;
        }
        
        this.submitFormApi(all_value);
    }

    submitFormApi(postData = null) {

        this.isButtonLoading    = true;
        postData.campaign_id    = this.campaign.form_id;
        postData.page_id        = this.current_page.form_id;
        postData.contact_form   = this.contact_form.form_id;
        postData.send_id        = this.send_idd;
        postData.country        = this.country;
        postData.list           = this.list;
        postData.user_id        = this.user_id;
        postData.utm_source     = this.utm_source;
        postData.utm_medium     = this.utm_medium;
        postData.utm_term       = this.utm_term;

        this.restApi.postData({ apikey: this.restApi.API_KEY, form_data: postData }, 'submit_contact_form').subscribe(response2 => {

            if (postData.email != "") {
                localStorage.setItem('UserEmail', postData.email);
            }
            
            if (response2.responseStatus = 1) {
                if (this.current_page.page_type === 'PDF') {
                    window.open(this.restApi.BaseUrl + "download_pdf/download/" + this.current_page.page_pdf);
                }

                let snackBarRef = this._snackBar.open(response2.responseMessage, 'OK', {
                    duration: 3000
                })
            
            }else if (response2.responseStatus == 2) {
                let snackBarRef = this._snackBar.open(response2.responseMessage, 'OK', {
                    duration: 3000
                })
            }
            this.dialogRef.close('Optional Data');
        })
    }

    CheckNumber(number) {
        if(number.toString().length == 10){
            return true;
        }else{
            return false;
        }
    }

    CheckEmail(email) {

        var pattern = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;
        if(email.match(pattern)) {
            return true;
        }else{
            return false;
        }
    }
}
